/* Meet Ivory - bundelkorting zichtbaar houden in de cart drawer.

   Nodig sinds de automatische Shopify-kortingen uit staan en Lasso Rewards de
   staffel doet: dan is original_line_price gelijk aan final_line_price, rekende
   renderCartTotalDiscount() 0 uit en verdween de kortingsregel uit de drawer.

   Dit bestand doet twee dingen:

   1. DE KORTINGSREGEL. Het tekent hem niet zelf; het rekent alleen het bedrag voor
      en laat de originele functie renderen, zodat de opmaak exact blijft zoals hij
      was: "Discount" met de naam in het grijze chipje ernaast. Het chipje wordt
      gevuld via een verborgen small.get_inner - hetzelfde element dat het theme
      zelf gebruikte toen Shopify de korting nog toepaste - zodat ook
      monitorInnerText() blijft kloppen.

   2. HET BEDRAG ACHTER "TOTAL". Dat schrijft theme.CartForm zelf, rechtstreeks uit
      de Shopify-cart (mrk.js: this.subtotal.innerHTML = ...), en die cart weet
      niets van de Reward. Zonder correctie stond er "Discount -$13.99" met daaronder
      onverkort $139.90, terwijl de checkout $125.91 rekent. Hier trekken we de
      korting er alsnog af, in dezelfde money-opmaak als het theme.

   Het totaal wordt alleen overschreven zolang er ook echt een staffel gehaald is.
   Zakt de cart onder de eerste staffel, of zet iemand de Shopify-kortingen weer aan,
   dan blijft het bedrag van het theme gewoon staan.

   LET OP: snippets/payment-icons.liquid wordt meerdere keren per pagina gerenderd,
   dus dit script laadt ook meerdere keren. De guard hieronder zorgt dat de override
   maar een keer geinstalleerd wordt; zonder guard stapelen ze op elkaar en toont het
   chipje de staffel van de vorige aanroep.
*/
(function () {
  if (window.__miBundlePreviewInstalled) return;

  var origineel = window.renderCartTotalDiscount;
  if (typeof origineel !== 'function') return;

  window.__miBundlePreviewInstalled = true;

  /* Wat de drawer op dit moment hoort te tonen. korting === 0 betekent: afblijven,
     het bedrag dat het theme zelf uitschrijft klopt dan al. */
  var stand = { totaal: 0, korting: 0 };

  function tierForQty(qty) {
    var tiers = window.MI_TIERS || [];
    var hit = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty) hit = tiers[i];
    }
    return hit;
  }

  /* Wat Lasso Rewards straks in de checkout aftrekt, of null als er geen staffel
     gehaald is. Lasso kapt centen af in plaats van af te ronden: zonder floor lopen
     drawer en checkout een cent uiteen (bij 3 stuks 17,98 hier vs 17,97 daar). */
  function kortingVoor(cart) {
    var tier = tierForQty(cart.item_count || 0);
    var pct = tier ? parseFloat(tier.label) / 100 : 0;
    if (!tier || !pct) return null;
    var bedrag = Math.floor(cart.total_price * pct);
    return bedrag > 0 ? { bedrag: bedrag, label: tier.label } : null;
  }

  function shopifyKorting(cart) {
    var som = 0;
    (cart.items || []).forEach(function (item) {
      som += (item.original_line_price - item.final_line_price);
    });
    return som;
  }

  function setChip(text) {
    var el = document.querySelector('small.get_inner[data-mi-chip]');
    if (!el) {
      el = document.createElement('small');
      el.className = 'get_inner';
      el.setAttribute('data-mi-chip', '');
      el.style.display = 'none';
      document.body.appendChild(el);
    }
    el.textContent = text;
  }

  /* ---- het bedrag achter "Total" ---- */

  /* Dezelfde formatter als mrk.js gebruikt, zodat valuta en scheidingstekens exact
     kloppen. De terugval leest de opmaak af uit wat er al staat. */
  function formatteer(centen, voorbeeld) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(
        centen,
        (theme.settings && theme.settings.moneyFormat) || undefined
      );
    }
    var match = voorbeeld ? voorbeeld.match(/\d[\d.,\s]*\d|\d/) : null;
    if (!match) return null;
    var komma = /,\d{2}$/.test(match[0]);
    var stukken = (centen / 100).toFixed(2).split('.');
    var geheel = stukken[0].replace(/\B(?=(\d{3})+(?!\d))/g, komma ? '.' : ',');
    return voorbeeld.replace(match[0], geheel + (komma ? ',' : '.') + stukken[1]);
  }

  function tekenTotaal() {
    if (stand.korting <= 0) return;
    var elementen = document.querySelectorAll('[data-subtotal]');
    for (var i = 0; i < elementen.length; i++) {
      var el = elementen[i];
      var tekst = formatteer(stand.totaal - stand.korting, el.textContent);
      /* Alleen schrijven als het echt verandert - anders houdt de observer
         hieronder zichzelf aan de gang. */
      if (tekst && el.textContent !== tekst) el.textContent = tekst;
    }
  }

  /* mrk.js overschrijft dat bedrag bij elke cart-update opnieuw (en ook nog vanuit
     reInit/AOS), dus corrigeren op alleen de cart-events is niet genoeg. */
  var bewaakt = [];
  function bewaakTotalen() {
    if (typeof MutationObserver !== 'function') return;
    var elementen = document.querySelectorAll('[data-subtotal]');
    for (var i = 0; i < elementen.length; i++) {
      if (bewaakt.indexOf(elementen[i]) !== -1) continue;
      bewaakt.push(elementen[i]);
      new MutationObserver(function () { tekenTotaal(); }).observe(elementen[i], {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function bijwerken(cart) {
    var korting = kortingVoor(cart);
    stand = { totaal: cart.total_price, korting: korting ? korting.bedrag : 0 };
    bewaakTotalen();
    tekenTotaal();
    return korting;
  }

  window.renderCartTotalDiscount = function (cart) {
    var container = document.getElementById('CartTotalDiscount');
    if (!container || !cart || !cart.items) return;

    /* Shopify past zelf korting toe: origineel gedrag, niets overnemen. */
    if (shopifyKorting(cart) > 0) {
      stand = { totaal: cart.total_price, korting: 0 };
      return origineel.apply(this, arguments);
    }

    var korting = bijwerken(cart);
    if (!korting) { setChip(''); container.innerHTML = ''; return; }

    setChip('EXTRA ' + korting.label + ' OFF');

    /* Laat het origineel renderen met een cart die precies dit bedrag oplevert. */
    return origineel({
      item_count: cart.item_count,
      total_price: cart.total_price,
      items: [{
        original_line_price: cart.total_price + korting.bedrag,
        final_line_price: cart.total_price,
        discount_allocations: []
      }],
      discount_applications: []
    });
  };

  /* mrk.js werkt het totaal bij in buildCart() en stuurt daarna pas cart:updated met
     de verse cart erbij. Daarop corrigeren we meteen, in plaats van te wachten op de
     /cart.js van updateCartTotalDiscount() - anders flikkert het oude bedrag. */
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart && cart.items && shopifyKorting(cart) <= 0) bijwerken(cart);
  });

  bewaakTotalen();
})();
